import script from "./VReferalSuccessLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./VReferalSuccessLabel.vue?vue&type=script&lang=ts&setup=true"

import "./VReferalSuccessLabel.vue?vue&type=style&index=0&id=0d70c388&lang=sass"

const __exports__ = script;

export default __exports__